import React, { ReactElement, useEffect } from 'react';
import { Link } from 'idsk-react-components';
import { useNavigate, useParams } from 'react-router';
import { useActionContext } from '../../../context/ConfirmActionContext';
import { useClient } from '../../../context/ClientStatusContext';
import { useCallbackContext } from '../../../context/CallbackActionContext';
import ConfirmActionType from '../../../model/ConfirmActionType';
import { sendPripomienky } from '../../../client/sendPripomienkyClient';
import routes from '../../../routing/routes';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import Pripomienka from '../../../model/pripomienka/Pripomienka';
import PripomienkaForSendRow from './PripomienkaForSendRow';
import './sendPripomienkyComponent.scss';

interface Props {
  pripomienkyForSend: Array<Pripomienka>;
}

const SendPripomienkyComponent = ({
  pripomienkyForSend,
}: Props): ReactElement => {
  const { displaySuccess } = useSuccessMessageContext();
  const { handleAction } = useActionContext();
  const { callback } = useCallbackContext();
  const navigate = useNavigate();
  const { wrapClient: sendPripomienkyClient } = useClient(sendPripomienky);
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const onSentPripomienky = async (): Promise<void> => {
    try {
      if (callback) {
        await callback();
      }
      await sendPripomienkyClient(type, year, index);
      navigate(routes.pripomienky.list.withParams(type, year, index));
      displaySuccess('Pripomienky boli úspešne odoslané.');
    } catch (e) { /* noop */
    }
  };

  useEffect(() => {
    if (pripomienkyForSend.length > 0) {
      handleAction(
        () => onSentPripomienky,
        'Naozaj si želáte odoslať nasledovné pripomienky za vašu organizáciu?',
        ConfirmActionType.NEGATIVE,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (pripomienkyForSend.length <= 0) {
    return (
      <div className="pripomienky-for-send-empty">
        <p className="text-center">Za vašu organizáciu aktuálne neevidujeme žiadne neodoslané pripomienky.</p>
        <Link to={routes.pripomienky.list.withParams(type, year, index)} type="button-secondary" size="large">
          Späť na zoznam
        </Link>
      </div>
    );
  }

  return (
    <div className="pripomienky-list">
      {pripomienkyForSend.map((pripomienka) => (
        <PripomienkaForSendRow
          key={pripomienka.uuid}
          pripomienka={pripomienka}
        />
      ))}
    </div>
  );
};

export default SendPripomienkyComponent;
